/**
 * useCreateDiscount Hook
 *
 * Mutation hook for creating a discount. On success, optimistically prepends
 * the new discount onto every cached list query so consumers (e.g. price-modifier
 * dropdowns) see it immediately, then invalidates the lists for a background
 * refetch from the server.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createDiscount,
  discountsQueryKeys,
  type DiscountsListResponse,
} from '../api/discounts';

export function useCreateDiscount() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createDiscount,
    onSuccess: ({ discount }) => {
      queryClient.setQueriesData<DiscountsListResponse>(
        { queryKey: discountsQueryKeys.lists() },
        (prev) =>
          prev
            ? { ...prev, discounts: [discount, ...prev.discounts] }
            : prev,
      );
      queryClient.invalidateQueries({ queryKey: discountsQueryKeys.lists() });
    },
  });
}
